module.exports = __webpack_public_path__ + "img/网站3-64.37f05b5d.png";